import React from "react";
import bankImage from "../../assets/bank.webp";

function LendersProblem() {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">
        <div className="grid grid-cols-1 items-center gap-10 md:gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-20 xl:gap-24">
          {/* Left: Content */}
          <div>
            {/* Label */}
            <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[12px]">
              THE PROBLEM
            </p>

            {/* Headline */}
            <h2 className="mt-5 font-bricolage text-[26px] font-semibold leading-[1.25] tracking-[-0.6px] text-[#f4f7f5] sm:text-[30px] md:text-[34px] lg:text-[36px]">
              Intake is noisy. Half the files do not match your policy, and the KYC breaks late.
            </h2>

            {/* Description */}
            <p className="mt-6 font-jakarta text-[15px] leading-[1.65] text-[#9fa9a5] sm:text-[16px]">
              Finverse filters upfront. You set the policy, verification runs before routing, and only matching files reach your desk.
            </p>
          </div>

          {/* Right: 3D Bank Illustration */}
          <div className="flex items-center justify-center lg:justify-end">
            <img
              src={bankImage}
              alt="Bank illustration"
              className="h-auto w-[220px] object-contain sm:w-[260px] md:w-[290px] lg:w-[320px]"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LendersProblem;
